module.exports = __webpack_public_path__ + "img/FR.d2878c69.png";